// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fy","advertDetailHeaderPrice__value":"c-m_fz","advertDetailHeaderPrice__label":"c-m_fA"};